import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { PieceMaxiLogoRenderComponent } from './piece-maxi-logo-render.component';


export const pieceMaxiLogoRenderModuleEntryComponents = [
  PieceMaxiLogoRenderComponent
];

@NgModule({
  imports: [
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
  ],
  declarations: pieceMaxiLogoRenderModuleEntryComponents
})
export class PieceMaxiLogoRenderModule {}

export default pieceMaxiLogoRenderModuleEntryComponents;

